/**
 * Decides whether a row belongs in the team "Pending" section.
 *
 * Two kinds of record feed that section: `team.invitations` (email invites and
 * the shareable team link) and `listPendingUserRequests` (people who asked to
 * join). A shareable team link is stored as an invitation with neither an email
 * nor a user, so it used to render as a permanently-pending blank row that
 * outlived approving the join request it came from (TA-10772). Such a row names
 * nobody and offers nothing to resend or revoke, so it is dropped — as is a row
 * for someone who is already an active member.
 *
 * Pure so it can be tested without mounting MembersTab.
 */

export type PendingInvitationIdentity = {
  email: string;
  user?: { id: string } | null;
};

export const isDisplayablePendingInvitation = (
  invitation: PendingInvitationIdentity,
  activeUserIds: Set<string>
): boolean => {
  const identifiesSomeone = !!invitation.user || !!invitation.email.trim();
  const isAlreadyAMember =
    !!invitation.user && activeUserIds.has(invitation.user.id);

  return identifiesSomeone && !isAlreadyAMember;
};
